const C_Path = "/ocr-order";
import { RouteDefine } from '@/types/route';
import Layout from '~/layout/index.vue'
const footerName = "ocr-order-list"
const OrderRoutes: RouteDefine = {
    path: C_Path,
    component: Layout,
    children: [
        {
            path: "list",
            name: footerName,
            component: () => import("./index.vue"),
            meta: {
                title: "OCR理货",
                isHeaderShow: false,
                isBack: false,
                footerName
            }
        },
        {
            path: "detail",
            name: 'ocr-order-detail',
            component: () => import("./detail.vue"),
            meta: {
                title: 'OCR理货明细',
                isBack: true,
                isHeaderShow: true,
                noFooter: true
            },
        },
        {
            path: "editor",
            name: 'ocr-order-editor',
            component: () => import("./order-editor.vue"),
            meta: {
                title: 'OCR理货编辑',
                isBack: true,
                isHeaderShow: true,
                noFooter: true,
            },
        }, {
            path: "detail-customer-editor",
            name: "ocr-order-detail-customer-editor",
            component: () => import("./item-editor-custom.vue"),
            meta: {
                title: "OCR理货明细",
                isBack: true,
                isHeaderShow: true,
                noFooter: true
            }

        }

    ]
}

export default OrderRoutes